<template>
  <div class="wrapper-video">
    <div class="view-video">
      <div>
        <div class="hidden-xs">
          <div class="close" @click="close">×</div>
        </div>
        <div class="visible-xs">
          <div class="close-xs" @click="close">×</div>
        </div>
      </div>
      <video :src="srcPath" controls="controls" autoplay="autoplay" :style="isMobile?{maxWidth:'100%'}:''" playsinline="true"
                   webkit-playsinline="true"
                   x-webkit-airplay="allow"
                   airplay="allow"
                   x5-video-player-type="h5"
                   x5-video-player-fullscreen="true"
                   x5-video-orientation="portrait" ref="video" id="video">
      </video>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    props: {
      srcPath: String
    },
    data () {
      return {}
    },
    components: {},
    mounted () {
      // $('body').addClass('overflowHidden')
    },
    methods: {
      close () {
        $('body').removeClass('overflowHidden');
        var video=document.getElementById('video');
        video.pause();
        this.$emit('closeVideo');

        // window.eventBus.$emit('initHomeBanner');
        //  window.eventBus.$emit('initCoreBanner');
      }
    },
    computed: {
      ...mapGetters(['isMobile'])
    }
  }
</script>

<style lang="scss" scoped>

  #dialog {
    border-radius: 15px;
    text-align: center;
    width: 50%;
    height: 50%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background-color: white;
  }

  .box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
  }

  .wrapper-video {
    position: fixed;
    width: 100%;
    height: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index:5000;
    .view-video {
      position: relative;
      width: 100%;
      height:100%;
      // max-width:40rem;
      // max-height: 50%;
      transform: translate(-50%,-50%);
      top:50%;
      left: 50%;
      overflow: hidden;
      max-width: 80rem;
      max-height: 50rem;
      // max-height: 80%;
      // width: 80%;
      // height: 80%;
      // max-width: 80%;
      // overflow: hidden;
      // height: 100%;
      // max-width: 75rem;
      // padding: 1.875rem;
      // top: 0;
      // right: 0;
      // bottom: 0;
      // left: 0;
      // margin: auto;
      // background: #FFFFFF;
      // box-shadow: 0 5px 15px rgba(0, 0, 0, .5);

      .close {
        position: absolute;
        top:0px;
        right:0px;
        border:2px solid #fff;
        // width: 1.125rem;
        // height: 1.125rem;
        text-align: center;
        line-height: 1.05rem;
        border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        cursor: pointer;
        color:#fff;
        text-shadow: none;
        opacity: 1;
        z-index: 10000;
      }

      .visible-xs {
         .view-video {
           max-height: 20rem ;
         }
        .close-xs {
          // position: absolute;
          // top: -0.2rem;
          // right: 0.475rem;
          // cursor: pointer;
          // font-size: 1.5rem;
          // z-index:100;
          position: absolute;
          top:26%;
          right:0px;
          border:2px solid #fff;
          // width: 1.125rem;
          // height: 1.125rem;
          text-align: center;
          // line-height: 1.05rem;
          border-radius: 50%;
          -moz-border-radius: 50%;
          -webkit-border-radius: 50%;
          cursor: pointer;
          color:#fff;
          text-shadow: none;
          opacity: 1;
          z-index: 100;
          width:20px;
          height:20px;
          line-height:16px;
          text-align: center;
        }
      }

      video {
        // width: 100%;
        // max-width: 71.25rem;
        // max-height: 50%;
        // max-height: 50%;
        position: absolute;
        // max-width: 38rem;
        // width: 100%;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        max-width:96%;
        width:100%;
        // height: 100%;
        // max-height:100%;
        object-fit: cover;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/MyPlayer.vue